import React from 'react';
import ArrowLeftBlack from "../Images/ArrowLeftBlack";
import BetaIcon from "../Images/BetaIcon";
import styled from "styled-components";

const BetaBadge:React.FC <{handleToggle: any}> = ({handleToggle}) => {
    return (
        <Container onClick={handleToggle} >
            <ArrowBlock>
                <ArrowLeftBlack/>
            </ArrowBlock>
            <BadgeBlock>
                <BetaIcon/>
                <span>beta</span>
            </BadgeBlock>
        </Container>
    );
};

export default BetaBadge;

const Container = styled.div`

    position: absolute;
    top: 35px;
    right: 0;
    background-color: #fff;
    color: #000;
    display: flex;
   justify-content: center;
    align-items: center;
    height: 46px;
`
const ArrowBlock = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    background-color: #F1D988;
`
const BadgeBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    font-family: ZenDots, sans-serif;
    font-size: 10px;
    font-weight: 400;
    row-gap: 2px;
`
